import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { LanguageProvider } from './i18n/LanguageContext';
import { ModelsProvider } from './hooks/ModelsContext';
import { installAuthInterceptor, AuthProvider } from './utils/auth.jsx';
import './index.css';

// Add auth header to all API requests automatically
installAuthInterceptor();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AuthProvider>
      <LanguageProvider>
        <ModelsProvider>
          <App />
        </ModelsProvider>
      </LanguageProvider>
    </AuthProvider>
  </React.StrictMode>
);
